@if (!disableCloseButton) {
  <button icon-button (click)="close()" class="close">
    <gl-icon [name]="'closeIcon'" class="closeIcon"></gl-icon>
  </button>
}
@if (!user.isPremium) {
  <img
    class="logo-icon"
    src="/assets/svg/logo-blue-text.svg"
    alt="Goodloading"
    />
}
@if (user.isPremium) {
  <img
    class="logo-icon"
    src="/assets/svg/logo-pro-blue-text.svg"
    alt="Goodloading"
    />
}
<div [ngClass]="{'pro': user.isPremium}">
  <header>
    <ng-content select="h2"></ng-content>
  </header>
  <ng-content></ng-content>
  <div class="form">
    <ng-content select="form"></ng-content>
  </div>
  <section class="buttons">
    <ng-content select=".buttons"></ng-content>
  </section>

  <section class="other">
    <ng-content select=".other"></ng-content>
  </section>
</div>
